import React from 'react';
import { Icon, List, Card } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';

class CommonSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    checkKnowledgeBank = (e, data) => {
        dispatch.community.setMainAreaContext("knowledgeBank");
        dispatch.account.setSelectedCategoryAsync({
            _id: 1,
            label: " Manage Knowledge Bank ",
            value: 'Knowledge Bank',

        });
        const history = this.props.history;
        history.push(`/app/platform/settings/public`)
    }

    render() {
        return (
            <div>
                <Card>
                    <Card.Header>Common Settings</Card.Header>
                    <Card.Content className="pad_0">
                        <List selection divided verticalAlign='middle'>
                            <List.Item as="a" className="multiLine" onClick={(e) => this.checkKnowledgeBank(e)}>
                                <List.Content floated='right'>
                                    <label>Public Knowledge Banks</label><Icon name="chevron right" />
                                </List.Content>
                                <List.Content >
                                    <List.Header>Knowledge Banks </List.Header>
                                    <span>Manage Knowledge Banks and further category to be used for content and playbook</span>
                                </List.Content>
                            </List.Item>

                        </List>
                    </Card.Content>
                </Card>
            </div >
        );
    }
}

export default CommonSettings;